import { Component, OnInit, ViewEncapsulation, HostBinding, Input } from '@angular/core';
import { AccountConfigService } from '../../../services/account-config/account-config.service';
import { MSession } from '@argalis-apps/models';
import { SessionService } from '../../../services/session/session.service';

@Component({
  selector: 'ags-session-presence',
  templateUrl: './session-presence.component.html',
  styleUrls: ['./session-presence.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SessionPresenceComponent implements OnInit {
  @HostBinding('class') themeFlag;
  public opened = false;
  //public check: boolean = true;
  public presenceInfo: MSession.IPresence[];
  public dataOfPresence: any[];
  public presenceApprenantInfoChoosed: MSession.IPresence;
  public presenceApprenantDataChoosed: MSession.ISessionApprenantPlanification;
  public idSession;
  public loader = true;
  @Input('idSession')
  set _idSession(value: string) {
    if (value) {
      this.idSession = value;
    }
  }

  constructor(private accountConfigService: AccountConfigService, private sessionService: SessionService) {}

  ngOnInit() {
    this.themeFlag = `${this.themeFlag || ''} ${this.accountConfigService.themingClassName}`;
    this.getPresenceInfo(this.idSession);
  }

  getPresenceInfo(idSession) {
    this.loader = true;
    this.presenceInfo = null;
    this.dataOfPresence = null;
    this.sessionService.getPresenceInfoBySession(idSession).subscribe(res => {
      this.presenceInfo = res;
      this.loader = false;
      if (this.presenceInfo[0]) this.dataOfPresence = this.presenceInfo[0].sessionApprenantPlanifications;
    });
  }

  /* Permet d'ouvrir la popup */
  open(presenceInfo: MSession.IPresence, plannifInfo: MSession.ISessionApprenantPlanification) {
    this.presenceApprenantInfoChoosed = presenceInfo;
    this.presenceApprenantDataChoosed = plannifInfo;
    this.opened = true;
  }
  /* Permet de fermer la popup */
  closePopup() {
    this.opened = false;
    this.getPresenceInfo(this.idSession);
  }
}
